var map = {
	"./address.json": "v1RN",
	"./articles.json": "ETri",
	"./biography.json": "aH03",
	"./education.json": "KhYF",
	"./exhibitions.json": "7kII",
	"./upcoming-events.json": "TTbK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hzKy";